module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_score.8f5e6.png";